import { Path } from '@/types/global';
import { FCRAWorker } from '@/types/turn-api';

export const path = (path: Path<FCRAWorker.Document>) => path;
